import service from './service-config';

export default {
  service,
};
